import { NgClass } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { TableModule } from 'primeng/table';
import { DialogTableDataRow } from '../../../../content/interfaces/dialog-table-data-row';
import { PaymentData } from '../../../../content/interfaces/payment/payment-data';
import { BankAccountToTableDataMapper } from '../../../../content/mapper/payment/bank-account-to-table-data-mapper.service';
import { EmailNotificationToTableDataMapper } from '../../../../content/mapper/payment/email-notification-to-table-data-mapper.service';
import { PaymentTypeToTableDataMapper } from '../../../../content/mapper/payment/payment-type-to-table-data-mapper.service';
import { ShopIntegrationToTableDataMapper } from '../../../../content/mapper/payment/shop-integration-to-table-data-mapper.service';
import { I18nService } from '../../../../core/services/i18n.service';
import { SpsActivationStatusTagComponent } from '../../sps-activation-status-tag/sps-activation-status-tag.component';
import { SpsMaskedPasswordComponent } from '../../sps-masked-password/sps-masked-password.component';
import { SpsPaymentStatusTagComponent } from '../../sps-payment-status-tag/sps-payment-status-tag.component';

@Component({
  selector: 'customer-payment-type-details-dialog',
  imports: [
    TableModule,
    NgClass,
    SpsPaymentStatusTagComponent,
    SpsActivationStatusTagComponent,
    SpsMaskedPasswordComponent
  ],
  templateUrl: './customer-payment-type-details-dialog.component.html',
})
export class CustomerPaymentTypeDetailsDialogComponent implements OnInit {

  i18n = inject(I18nService);
  paymentTypeMapper = inject(PaymentTypeToTableDataMapper);
  bankAccountMapper = inject(BankAccountToTableDataMapper);
  shopIntegrationMapper = inject(ShopIntegrationToTableDataMapper);
  emailNotificationMapper = inject(EmailNotificationToTableDataMapper);

  @Input() paymentTypeData: PaymentData;
  @Input() tenantId: string;
  @Input() titleColumnWidth: string = 'auto';
  @Input() valueColumnWidth: string = 'auto';

  tableData: DialogTableDataRow[] = [];

  /**
   * Map table data on component initialization
   */
  ngOnInit() {
    this.tableData = [
      {
        titleColspan: true,
        titleStyleClass: 'text-lg font-bold pb-4',
        i18nTitleKey: 'PAYMENTTYPETITLE'
      }
    ]
    this.tableData.push(...this.paymentTypeMapper.map(this.paymentTypeData, true));
    this.tableData.push(
      {
        titleColspan: true,
        titleStyleClass: 'text-lg font-bold pt-5 pb-4',
        i18nTitleKey: 'BANKACCOUNT'
      }
    )
    this.tableData.push(...this.bankAccountMapper.map(this.paymentTypeData));
    this.tableData.push(
      {
        titleColspan: true,
        titleStyleClass: 'text-lg font-bold pt-5 pb-4',
        i18nTitleKey: 'PAYMENTTYPETECHDATA'
      }
    )
    this.tableData.push(...this.shopIntegrationMapper.map(this.paymentTypeData, this.tenantId));
    this.tableData.push(
      {
        titleColspan: true,
        titleStyleClass: 'text-lg font-bold pt-5 pb-4',
        i18nTitleKey: 'EMAILNOTIFICATION'
      }
    )
    this.tableData.push(...this.emailNotificationMapper.map(this.paymentTypeData));
  }

}
